export default "__VITE_ASSET__eb8ce2fe__"